import { PrivacyAgreementService } from './../../../core/services/privacy-agreement.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ms-privacy-agreement',
    templateUrl: './privacy-agreement.component.html',
    styleUrls: ['./privacy-agreement.component.scss'],
})
export class PrivacyAgreement implements OnInit {
    public privacyagreementGDPR1: string;
    public privacyagreementGDPR2: string;
    public privacyagreementVsZucchetti: string;
    public privacyagreementvsThird: string;
    @Input() userID: string = '';

    public cmsObj: CmsObject[];

    constructor(
        public workFlow: WorkFlowService,
        private cmsService: CmsService,
        public customerService: CustomerService,
        public privacyAgreementService: PrivacyAgreementService
    ) {}

    async ngOnInit() {
        await this.getCmsObj();
    }

    async getCmsObj() {
        const lang = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(lang, 'privacyagreement');
        this.privacyagreementGDPR1 = this.cmsObj.find((x) => x.ContentName == 'privacyagreement.gdpr1').ContentTranslation;
        this.privacyagreementGDPR2 = this.cmsObj.find((x) => x.ContentName == 'privacyagreement.gdpr2').ContentTranslation;
        this.privacyagreementVsZucchetti = this.cmsObj.find((x) => x.ContentName == 'privacyagreement.box1').ContentTranslation;
        this.privacyagreementvsThird = this.cmsObj.find((x) => x.ContentName == 'privacyagreement.box2').ContentTranslation;
    }

    async onValueChangePersonalDataAgreeInt(event: any) {
        this.privacyAgreementService.PersonalDataAgreeInt = event.checked;
        if (this.customerService.customer)
            this.customerService.customer.PersonalDataAgreeInt = this.privacyAgreementService.PersonalDataAgreeInt;
    }

    async onValueChangePersonalDataAgreeExt(event: any) {
        this.privacyAgreementService.PersonalDataAgreeExt = event.checked;
        if (this.customerService.customer)
            this.customerService.customer.PersonalDataAgreeExt = this.privacyAgreementService.PersonalDataAgreeExt;
    }
    viewPdf() {
        if (this.workFlow.languageIsItalian()) {
            return 'https://www.zucchetti.it/website/cms/privacy.html';
        } else {
            return 'https://www.zucchetti.com/worldwide/cms/privacy.html';
        }
    }
}
